import { create } from 'zustand';

interface NotificationTrayState {
	isOpen: boolean;
	open: () => void;
	close: () => void;
}

/**
 * PD-16475 — whether the notifications tray opened from the mobile menu
 * drawer is showing. A store (like `useMenuDrawerStore`) because the drawer
 * that opens it and the layout that renders it are far apart.
 */
export const useNotificationTrayStore = create<NotificationTrayState>(
	(set) => ({
		isOpen: false,
		open: (): void => {
			set({ isOpen: true });
		},
		close: (): void => {
			set({ isOpen: false });
		},
	}),
);
